import { hasOwnProperty } from 'smob'

// convert reserved prop names to something else to use with bind / props
export const safeBindTransform = function (data: object) {
  const converted = { ...data }

  // convert the 'style' property
  if (hasOwnProperty(converted, 'style')) {
    converted.variant = converted.style
    delete converted.style
  }

  return converted
}

// escape HTML special chars so a string is safe to render with v-html
export const escapeHtml = function (value: string | null | undefined) {
  if (!value) { return value }

  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export const sanitizeMarkedHeading = function (title: string | null | undefined) {
  if (title) {
    // remove {{ }}
    let result: string | string[] = title.split(/\{\{(.+)\}\}/gm)
    result = result.join('')

    // remove &shy;
    result = result.replace(/&shy;/gi, '')

    return result
  }
  return title
}
